export default __webpack_public_path__ + "static/media/account.774140f8.svg";